import React from 'react';

import NavBar from './NavBar';
import { useStore } from '../../store';
import ChatBot from '../../flows/chatBot';
import { validateFeatureFlag } from '../../services/featureFlagService';
import { FEATURE_FLAG } from '../../constants/general';
import { CustomerProfile } from '../../components/CustomerProfile/CustomerProfile';

interface IProps {
  layoutStyle: string;
  children: React.ReactNode;
  navChildren?: React.ReactNode;
  backDestination?: number;
  title?: string;
  titleStyle?: string;
  assetPath?: string;
  navBarStyle: string;
  backButtonStyle?: string;
  handleNavigate?: () => void;
  backButtonId?: string;
  isWizardMode?: boolean
  isChatBotEnabled?: boolean
  chatBotStyle?: string;
  hideCustomerProfile?: boolean,
}

const AppLayout = ({
  layoutStyle, children, backDestination, title, assetPath, titleStyle, navBarStyle, backButtonStyle, navChildren, handleNavigate, backButtonId, isWizardMode, isChatBotEnabled = true,
  chatBotStyle, hideCustomerProfile,
}: IProps) => {
  const userData = useStore(state => state.getSummaryData());
  const { customer, accounts } = userData;
  return (
    <div className={`${layoutStyle} fadeIn min-h-[835px]`}>
      {(customer && accounts && !isWizardMode) && <CustomerProfile isHidden={hideCustomerProfile} />}
      {validateFeatureFlag(FEATURE_FLAG.ADA_BETA) && isChatBotEnabled && <ChatBot chatBotStyle={chatBotStyle} />}
      <NavBar
        navChildren={navChildren}
        navBarStyle={navBarStyle}
        title={title}
        assetPath={assetPath}
        backButtonId={backButtonId}
        titleStyle={titleStyle}
        backButtonStyle={backButtonStyle}
        backDestination={backDestination}
        handleNavigate={handleNavigate}
      />
      {children}
    </div>
  );
};

export default AppLayout;
